import isString from 'lodash/isString';
import cloneDeep from 'lodash/cloneDeep';
import { Literal, RemirrorJSON } from 'remirror';

export function isSameDomain(href: string) {
  const url = new URL(href);
  return url.hostname === window.location.hostname;
}

export function getForwardRef(href: string) {
  const url = new URL(href);
  let forwardRef = url.pathname;
  if (url.search) forwardRef += url.search;
  if (url.hash) forwardRef += '#' + url.hash;

  return forwardRef;
}

export interface EditorTodoType {
  id: string;
  text: UnknownJSON;
}

type TodosType = (EditorTodoType | null)[];

function getTodo(todoNodeId: Literal, todos: TodosType) {
  for (let i = 0; i < (todos.length || 0); i++) {
    const todoText = todos[i]?.text as RemirrorJSON;
    if (todoText && todoText.attrs?.todoNodeId === todoNodeId) {
      return todoText;
    }
  }
}

export function changeTodos(content: any, todos: TodosType) {
  const data = cloneDeep(content as RemirrorJSON);
  if (data.type === 'doc' && data.content?.length) {
    const deletedTodos: number[] = [];
    for (let i = 0; i < data.content.length; i++) {
      if (
        data.content[i].type === 'todo' &&
        typeof data.content[i].attrs?.todoNodeId === 'string'
      ) {
        const todo = getTodo(data.content[i].attrs!.todoNodeId, todos);
        if (todo) {
          data.content[i] = todo;
        } else {
          deletedTodos.push(i);
        }
      }
    }
    while (deletedTodos.length) {
      const idx = deletedTodos.pop();
      if (idx) {
        delete data.content[idx];
      }
    }
    data.content = data.content.filter((v) => !!v);
  }
  return data;
}

export function filterTodosContent(content: string) {
  const data = JSON.parse(content) as RemirrorJSON;

  if (data?.type !== 'doc' || !data.content) {
    return content;
  }

  for (let i = 0; i < data.content.length; i++) {
    if (data.content[i].type === 'todo') {
      data.content[i].content = [];
    }
  }

  return JSON.stringify(data);
}

export function canSaveContent(content: string): boolean {
  const data = JSON.parse(content) as RemirrorJSON;

  return !hasTodoBeingCreated(data);
}

function hasTodoBeingCreated(data: RemirrorJSON): boolean {
  if (data?.type !== 'doc' || !data.content) {
    return false;
  }
  for (let i = 0; i < data.content.length; i++) {
    if (
      data.content[i].type === 'todo' &&
      data.content[i].attrs?.todoNodeId === ''
    ) {
      return true;
    }
  }
  return false;
}

export function loadImage(url: string) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener('load', () => resolve(img));
    img.addEventListener('error', (err) => reject(err));
    img.src = url;
  });
}

export function changeFilesUrlToCurrentLocation(content: any) {
  const data = cloneDeep(content as RemirrorJSON);
  if (data.type === 'doc' && data.content?.length) {
    data.content.forEach((node) => {
      if (node.type === 'image') {
        replaceUrl(node);
      } else {
        node.content?.forEach((node) => {
          if (node.type === 'image') {
            replaceUrl(node);
          }
        });
      }
    });
  }
  return data;
}

function replaceUrl(node: RemirrorJSON) {
  if (
    node.attrs?.src &&
    isString(node.attrs.src) &&
    node.attrs.src.startsWith('https://')
  ) {
    const path = node.attrs.src.split('/').slice(3).join('/');
    node.attrs.src = `https://${window.location.hostname}/${path}`;
  }
}
